export default __webpack_public_path__ + "media/connector.42398071.svg";